import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, Typography } from "@mui/material";
import RequestDetails from "components/Admin/RequestDetails";

class RequestDetailsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
  }

  componentDidMount() {
    let vendorId;
    if (this.props?.location?.VendorDetailId) {
      localStorage.setItem(
        "vendorId",
        JSON.stringify(this.props?.location?.VendorDetailId)
      );
      vendorId = this.props?.location?.VendorDetailId;
    } else {
      vendorId = localStorage.getItem("vendorId");
      if (vendorId) vendorId = JSON.parse(vendorId);
    }
    if (vendorId) {
      this.props.getVendorDetailsAction({ id: vendorId });
    }
  }

  render() {
    const data = this.props?.VendorDetailList?.result;

    return (
      <Grid container>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/vendor/request "
            >
              Vendor
            </Link>
            <Typography sx={{ fontSize: "14px" }} color=" #0DA861">
              View Details
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <RequestDetails data={data} />
          </Paper>
        </Grid>
      </Grid>
    );
  }
}
export default RequestDetailsContainer;
